/* Affiliates apply form: two quiet bot checks on top of Shopify's own (or the handler's) bot protection.
   - Honeypot: a field people never see (contact[Fax]). If it has a value, the form is not sent.
   - Time check: an application sent less than 4 seconds after the page opened is not sent.
   Both run on window in the capture phase, so they act before ow-forms.js lets the native post continue.
   With an apply endpoint, the handler redirects back with ?applied=1 and this script shows the thank-you note. */
(function () {
  'use strict';
  var form = document.querySelector('[data-af-form]');
  if (!form) return;
  var opened = Date.now();
  var hp = form.querySelector('[data-af-hp]');
  var secs = form.querySelector('[data-af-secs]');
  window.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var elapsed = Math.round((Date.now() - opened) / 1000);
    if (secs) secs.value = String(elapsed);
    if ((hp && hp.value) || elapsed < 4) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    /* Endpoint mode: post in the background and show the note here. Without JavaScript the browser posts and the handler
       answers with its own thank-you page and a link back. */
    if (form.hasAttribute('data-ow-contact') || !form.checkValidity() || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(form.action, { method: 'POST', mode: 'no-cors', body: new URLSearchParams(new FormData(form)) })
      .then(function () { form.reset(); showSent(); })
      .catch(function () { form.submit(); });
  }, true);
  form.addEventListener('invalid', function (e) { e.target.setAttribute('aria-invalid', 'true'); }, true);
  form.addEventListener('input', function (e) { if (e.target.checkValidity && e.target.checkValidity()) e.target.removeAttribute('aria-invalid'); });
  var sent = form.querySelector('[data-af-sent]');
  function showSent() {
    if (!sent) return;
    sent.hidden = false;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    try { sent.focus(); } catch (err) {}
  }
  if (/[?&]applied=1\b/.test(location.search)) showSent();
})();
